var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowImoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2476 28.5C22.875 28.5 28.2476 23.1274 28.2476 16.5C28.2476 9.87258 22.875 4.5 16.2476 4.5C9.62018 4.5 4.2476 9.87258 4.2476 16.5C4.2476 23.1274 9.62018 28.5 16.2476 28.5Z",
    fill: "#EB9530",
    stroke: "#EB9530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9141 15.1665C14.0187 15.1665 14.9141 14.2711 14.9141 13.1665C14.9141 12.0619 14.0187 11.1665 12.9141 11.1665C11.8095 11.1665 10.9141 12.0619 10.9141 13.1665C10.9141 14.2711 11.8095 15.1665 12.9141 15.1665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5811 15.1665C20.6857 15.1665 21.5811 14.2711 21.5811 13.1665C21.5811 12.0619 20.6857 11.1665 19.5811 11.1665C18.4765 11.1665 17.5811 12.0619 17.5811 13.1665C17.5811 14.2711 18.4765 15.1665 19.5811 15.1665Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1969 21.3085C18.8723 21.3086 18.3612 21.3085 16.1893 21.3085C14.0174 21.3085 14.1877 21.3085 10.2983 21.3085",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowImoji);
export default __webpack_public_path__ + "static/media/yellowImoji.4062ce4193bea02e1272305334fbbde8.svg";
export { ForwardRef as ReactComponent };